import {put,takeLatest,call} from 'redux-saga/effects';
import * as userService from "../../../services/userService";
import {
    UPDATE_USER,
    UPDATE_USER_SUCCESS,
    UPDATE_USER_ERROR,
}
    from "../../actions/user";

function* updateUserSaga(action) {
    try {

        const data = !action.payload.dontCallDb ? yield call(userService.UpdateUser,action.payload) : action.payload.user

        
        yield put({
            type: UPDATE_USER_SUCCESS,
            payload: data
        });


    } catch(error) {
        yield put({
            type: UPDATE_USER_ERROR,error: error.data
        });
    }
}


export function* updateUserSagaWatcher() {
    yield takeLatest(UPDATE_USER,updateUserSaga);
}